module.exports = __webpack_public_path__ + "img/jdjbicon3.bfa3ec09.png";